"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimecardReminderType = void 0;
exports.instanceOfTimecardReminderType = instanceOfTimecardReminderType;
exports.TimecardReminderTypeFromJSON = TimecardReminderTypeFromJSON;
exports.TimecardReminderTypeFromJSONTyped = TimecardReminderTypeFromJSONTyped;
exports.TimecardReminderTypeToJSON = TimecardReminderTypeToJSON;
exports.TimecardReminderTypeToJSONTyped = TimecardReminderTypeToJSONTyped;
/**
 *
 * @export
 */
exports.TimecardReminderType = {
    Advance: 'advance',
    Cutoff: 'cutoff'
};
function instanceOfTimecardReminderType(value) {
    for (const key in exports.TimecardReminderType) {
        if (Object.prototype.hasOwnProperty.call(exports.TimecardReminderType, key)) {
            if (exports.TimecardReminderType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function TimecardReminderTypeFromJSON(json) {
    return TimecardReminderTypeFromJSONTyped(json, false);
}
function TimecardReminderTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function TimecardReminderTypeToJSON(value) {
    return value;
}
function TimecardReminderTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=TimecardReminderType.js.map